/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { AnimatePresence } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import {
  Nav,
  RouteLink,
  NavLogo,
  NavRoutes,
  RouteIcon,
  RouteName,
  NavTopSection,
  NavBars,
  NavDivider,
} from './navbarElements';
import Logo from '../../Images/General/logoWhite.png';
import { Routes } from './routes';
import useAuth from '../../Hooks/useAuth';
import { logoAnimation, showAnimation } from './anims';
import useDeviceDetect from '../../Hooks/checkDevice';

const NavbarSection = () => {
  const { isMobile } = useDeviceDetect();
  const { auth } = useAuth();

  const [isOpen, setIsOpen] = useState(!isMobile);

  const toggle = () => setIsOpen(!isOpen);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleHome = async () => {
    if (location.pathname !== '/') {
      await navigate('/');
    }
    scroll.scrollToTop();
  };

  return (
    <Nav
      isMobile={isMobile}
      initial={{
        width: !isMobile ? '300px' : '0px',
        minWidth: !isMobile ? '300px' : '0px',
      }}
      animate={{
        width: isOpen ? '300px' : (isMobile ? '0px' : '70px'),
        minWidth: isOpen ? '300px' : (isMobile ? '0px' : '70px'),
        transition: {
          duration: 0.5,
          type: 'spring',
          damping: 15,
        },
      }}
    >
      <NavTopSection>
        <AnimatePresence>
          {isOpen && (
            <NavLogo
              onClick={() => { toggleHome(); if (isMobile) toggle(); }}
              initial="hidden"
              animate="show"
              exit="hidden"
              variants={logoAnimation}
              src={Logo}
            />
          )}
        </AnimatePresence>
        <NavBars isMobile={isMobile} onClick={toggle}><FaBars style={{ verticalAlign: 'middle' }} /></NavBars>
      </NavTopSection>
      <NavRoutes>
        {Routes.filter((item) => {
          if (item.roles.includes(parseInt(auth.roles, 10))) return true;
          return false;
        }).map((route) => (
          <div key={route.name}>
            <RouteLink onClick={isMobile && toggle} to={route.path}>
              {(isOpen && isMobile) && <RouteIcon>{route.icon}</RouteIcon>}
              {!isMobile && <RouteIcon>{route.icon}</RouteIcon>}
              <AnimatePresence>
                {isOpen && (
                <RouteName
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  variants={showAnimation}
                >
                  {route.name}
                </RouteName>
                )}
              </AnimatePresence>
            </RouteLink>
            {(isOpen && isMobile) && <NavDivider />}
            {!isMobile && <NavDivider />}
          </div>
        ))}
      </NavRoutes>
    </Nav>
  );
};

export default NavbarSection;
